import React from 'react'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { routesConfig } from './Routes';
import { useCredit } from '../context/CreditContext';
import { useAppContext } from '../context/AppContext';

function ProtectedRoutes(props) {

    const { isAuthenticated, centralLoadingFlags, tostAlert, selectedUser, emailVerified, collectionTypeList, fetchCollectionTypes,
        fetchPublishedCollection,
        fieldSetList, fetchFieldSets,
        fieldSetListPublished, collectionPublishedList, fetchPublishedFieldset, staffList, open, setOpen } = props;

    const location = useLocation();
    const navigate = useNavigate();
    const currentPath = location.pathname;
    const { isProExpired, projectUsed, creditLoading } = useCredit();
    const { selectedOrganization } = useAppContext();

    const jwtIdToken = localStorage.getItem('dpod-token');
    if (!jwtIdToken) {
        localStorage.clear()
        sessionStorage.clear()
        navigate("/login")
    }

    const matchRoute = (route) => {
        let regexPath = route.path.replace(/:\w+/g, '[^/]+').replace(/\/\*$/, '(?:/.*)?');
        const regex = new RegExp(`^${regexPath}$`);
        return regex.test(currentPath);
    };

    const currentRoute = routesConfig.find(matchRoute)

    if (currentRoute?.requiresActivePlan && !creditLoading && isProExpired) {
        const orgId = selectedOrganization?.payload?.__auto_id__ ?? null;
        if (orgId) {
            return <Navigate
                to={`/organization/${orgId}/select-active-project`}
                replace
                state={{ project_used: projectUsed }}
            />;
        }
    }

    if (currentRoute) {
        return <Outlet context={{
            isAuthenticated,

            centralLoadingFlags,
            tostAlert,
            selectedUser,
            emailVerified,
            location,
            navigate,

            collectionTypeList,
            fetchCollectionTypes,
            fetchPublishedCollection,

            fieldSetList,
            fetchFieldSets,
            fieldSetListPublished,
            collectionPublishedList,
            fetchPublishedFieldset,

            staffList,

            open,
            setOpen
        }} />;
    }
}

export default ProtectedRoutes;